@if (showLogin()) {
  <div class="dmb-page-wrapper no-menu">
    <dmb-login />
  </div>
} @else if (showLogin() === false) {
  <div class="dmb-page-wrapper" id="main-scroller" cdkScrollable>
    <dmb-combined-menu />
    <div class="main">
      <dmb-popup-center />
      <router-outlet />
    </div>
  </div>
}
<dmb-spinner />
